'use client'

import { Modal, ModalBody, ModalContent, useDisclosure } from '@nextui-org/modal'

import { AnimationDefinition } from 'framer-motion'

import { FC, useEffect, useRef, useState } from 'react'

import { getColorBtnSite, styles } from '@/app/shared/components/modals/modal/services'
import { ITypeSite } from '@/app/shared/store/layout.store'
import useModal, { IModalItem } from '@/app/shared/store/modals.store'

// interface
interface IModal extends IModalItem {
  typeSite: ITypeSite | null
}

// component
const ModalComponent: FC<Readonly<IModal>> = ({
  component: CustomComponent,
  additional,
  props,
  name,
  typeSite,
}) => {
  const { onOpenChange, isOpen } = useDisclosure()
  const [isFirst, setIsFirst] = useState<boolean>(true)
  const close = useModal((state) => state.close)
  const activeModals = useModal((state) => state.activeModals)

  const modalRef = useRef<HTMLElement | null>(null)

  const closeHandle = (status: AnimationDefinition) => {
    if (status === 'exit' && name) {
      close(name)
    }
  }

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false)
      onOpenChange()
    }
  }, [onOpenChange, isFirst])

  // return
  return (
    <Modal
      placement={'bottom-center'}
      aria-labelledby='modal'
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      ref={modalRef}
      scrollBehavior={
        activeModals?.find((el) => el?.component.displayName === 'CourseInfoComponent')
          ? 'inside'
          : 'normal'
      }
      motionProps={{
        onAnimationComplete: (e) => closeHandle(e),
      }}
      classNames={styles(getColorBtnSite(typeSite))}
      {...additional}
    >
      <ModalContent>
        {(onClose: () => void) => (
          <ModalBody>
            <CustomComponent {...props} onClose={onClose} typeSite={typeSite} />
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  )
}

export default ModalComponent
